import "./meetingList.scss";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import MeetingTable from "../meetingtable/MeetingTable";

const MeetingList = () => {
  return (
    <div className="list">
      <Sidebar />
      <div className="listContainer">
        <Navbar />
        <MeetingTable />
      </div>
    </div>
  );
};

export default MeetingList;
